/**
 =========================================================
 * Material Dashboard 2 React - v2.2.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2023 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import { useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useSetRecoilState } from "recoil";
import { authProfile } from "../../../recoilStates";
import { signInFirebase } from "../../../assets/firebaseAuth";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";

function Basic() {
  const [rememberMe, setRememberMe] = useState(false);
  const setAuthUser = useSetRecoilState(authProfile);
  const navigate = useNavigate();
  const [toast, setToast] = useState(false);
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const [userCredentials, setUserCredentials] = useState({
    email: "",
    password: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    signInFirebase(userCredentials?.email, userCredentials?.password).then((res) => {
      if (!res?.message) {
        setAuthUser(res);
        navigate("/");
        setToast({
          msg: "Success!",
          variant: "success",
        });
      } else {
        setToast({
          msg: `${res?.message}`,
          variant: "error",
        });
      }
    });
  };

  return (
    <BasicLayout image={bgImage}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={toast} autoHideDuration={6000} onClose={() => setToast(false)}>
        <Alert
          onClose={() => setToast(false)}
          severity={toast?.variant}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {toast?.msg}
        </Alert>
      </Snackbar>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox onSubmit={handleSubmit} component="form" role="form">
            <MDBox mb={2}>
              <MDInput onChange={(e) => {
                setUserCredentials({ ...userCredentials, email: e?.target.value });
              }} required value={userCredentials?.email} type="email" label="Email" fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDInput onChange={(e) => {
                setUserCredentials({ ...userCredentials, password: e?.target.value });
              }} required value={userCredentials?.password} type="password" label="Password" fullWidth />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type={"submit"} variant="gradient" color="info" fullWidth>
                sign in
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
